import { decryptInteger } from "@/Utils/encryptInteger";
import { createContext, useContext, useState, useEffect } from "react";
import { useBuy } from "./buy";
import { useLoading } from "./loading";
import { notFound } from "next/navigation";

const ShowsContext = createContext(null);

export function ShowsProvider({ children }) {
  const { isCalled, setLoggedUserDetails, selectedState, setSelectedState, setSelectedIndex } =
    useBuy();
  const [shows, setShows] = useState([]);
  const [selectedShows, setSelectedShows] = useState();
  const [states, setStates] = useState([]);
  const [showsListing, setShowsListing] = useState([]);
  const [time, setTime] = useState("week");
  const [loading, setLoading] = useState(false);
  const [intialLoading, setInitialLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setInitialLoading(true);
    function getToken(val) {
      try {
        let encryptedData = localStorage.getItem("user_data");
        if (encryptedData) {
          let data = JSON.parse(decryptInteger(encryptedData));
          return val == "token" ? data?.web_token || null : data?.state;
        }
        return null;
      } catch (error) {
        console.error("Error fetching web token:", error);
        return null;
      }
    }

    const state = getToken("state");

    async function fetchStates() {
      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageState`,
          {
            method: "POST",
            body: new URLSearchParams({
              action: "getState",
            }),
          }
        );
        const data = await response.json();
        let updatedStates = data.data;
        if (state) {
          const stateIndex = updatedStates.findIndex((st) => st.code == state);

          if (stateIndex == -1) {
            updatedStates = data.data;
            setSelectedState(updatedStates[0]);
          } else {
            const selectedState = updatedStates[stateIndex];

            updatedStates.splice(stateIndex, 1);
            updatedStates.unshift(selectedState);

            setSelectedState(selectedState);
          }
        } else {
          setSelectedState(updatedStates[0]);
        }

        setStates(updatedStates);
      } catch (error) {
        console.error("Error fetching states:", error);
      } finally {
        setInitialLoading(false);
      }
    }

    fetchStates();
  }, []);

  useEffect(() => {
    setLoading(true);
    if (!selectedState?.code) {
      return;
    }

    const getToken = (val) => {
      try {
        const encryptedData = localStorage.getItem("user_data");
        if (encryptedData) {
          const data = JSON.parse(decryptInteger(encryptedData));
          const tokenOrState =
            val === "token" ? data?.web_token || null : data?.state;
          return tokenOrState;
        }
      } catch (error) {
        console.error("Error fetching token:", error);
      }
      return null;
    };

    const webToken = getToken("token");
    const headers = webToken ? { Authorization: `Bearer ${webToken}` } : {};

    const buildFormData = (period) => {
      const formData = new FormData();
      formData.append("action", "getShow");
      formData.append("by_period", period);
      formData.append("state_code", selectedState.code);
      return formData;
    };

    const fetchWeekShows = async (period, isRetry = false) => {
      setTime(period);
      try {
        const formData = buildFormData(period);
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageShow`,
          {
            method: "POST",
            body: formData,
            headers,
          }
        );
        const data = await response.json();

        if (!data) {
          notFound();
        }

        if (data.tsc === 400) {
          localStorage.clear();
          sessionStorage.clear();
          setLoggedUserDetails(null);
        }

        if (data.data.length === 0 && period === "week" && !isRetry) {
          fetchWeekShows("all", true);
          return;
        } else {
          setShows(data.data);
          setSelectedIndex(0);
        }
      } catch (error) {
        console.error("Error fetching week shows:", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 350)
      }
    };

    const fetchShows = async () => {
      try {
        const formData = buildFormData("all");
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageShow`,
          {
            method: "POST",
            body: formData,
            headers,
          }
        );
        const data = await response.json();
        setShowsListing(data.data);
      } catch (error) {
        console.error("Error fetching show listing:", error);
      }
    };

    fetchShows();
    fetchWeekShows("week");
  }, [selectedState, isCalled]);

  return (
    <ShowsContext.Provider
      value={{
        shows,
        setShows,
        selectedState,
        setSelectedState,
        selectedShows,
        setSelectedShows,
        states,
        setStates,
        showsListing,
        setShowsListing,
        time,
        setTime,
        loading,
        setLoading,
        intialLoading,
        setInitialLoading,
      }}
    >
      {children}
    </ShowsContext.Provider>
  );
}

export function useShows() {
  return useContext(ShowsContext);
}
